import {
  type TypedUseSelectorHook,
  useSelector as useUntypedSelector,
} from 'react-redux';

import { type HostState } from '../types';

export const useSelector: TypedUseSelectorHook<HostState> = useUntypedSelector;
